import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ProtoResponse } from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { DateRange, FilterBy, ReportType, ReportStatus } from './models/reports.constants';
import { ReportCenterApiService } from './report-center-api';

@Injectable()
export class GetCompanyReportService extends ReportCenterApiService<any, GetCompanyReportResponse> {
    public endpointName = 'v1/report';
    public requestType = undefined;
    public responseType = GetCompanyReportResponse;

    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }

    public getReport(companyRoleId: string, reportId: string): Promise<GetCompanyReportResponse> {
        const url = `${this.endpointUrl}/${companyRoleId}/${reportId}`;
        return new Promise<GetCompanyReportResponse>((resolve, reject) => {
            // tslint:disable-next-line: no-floating-promises
            this._http
                .get<GetCompanyReportResponse>(url)
                .toPromise()
                .then((response) => {
                    // We filter out undefined because a closed stream will send undefined if the promise has not resolved
                    if (response !== undefined) {
                        resolve(response);
                    } else {
                        reject(null);
                    }
                })
                .catch((response) => reject(response));
        });
    }
}

// back end return needs to be improved
export class GetCompanyReportResponse extends ProtoResponse {
    public error: Error;
    public message: string;
    public companyRoleId: number;
    public createdDate: string;
    public dateRange: DateRange;
    public description: string;
    public enableFooterTotals: boolean;
    public endDate: string;
    public filterBy: FilterBy;
    public id: number;
    public isGlobal: boolean;
    public lastRun: string;
    public modifiedDate: string;
    public name: string;
    public reportType: ReportType;
    public startDate: string;
    public status: ReportStatus;
    public userName: string;

    constructor(obj?: Partial<GetCompanyReportResponse>) {
        super();
        this.error = obj?.error || null;
        this.message = obj?.message || null;
        this.companyRoleId = obj?.companyRoleId || 0;
        this.createdDate = obj?.createdDate || null;
        this.dateRange = obj?.dateRange || null;
        this.description = obj?.description || null;
        this.enableFooterTotals = obj?.enableFooterTotals || false;
        this.endDate = obj?.endDate || null;
        this.filterBy = obj?.filterBy || null;
        this.id = obj?.id || 0;
        this.isGlobal = obj?.isGlobal || false;
        this.lastRun = obj?.lastRun || null;
        this.modifiedDate = obj?.modifiedDate || null;
        this.name = obj?.name || null;
        this.reportType = obj?.reportType || null;
        this.startDate = obj?.startDate || null;
        this.status = obj?.status || ReportStatus.All;
        this.userName = obj?.userName || null;
    }
}
